import { atom } from "recoil";

export interface OrdererState {
  ordererBusinessName: string; // 공급자 정보
  ordererPhone: string;
  ordererName: string; // 고객명
  ordererMail: string;
  constructionName: string;
  constructionWorkName: string;
}

export const ordererState = atom<OrdererState>({
  key: "ordererState",
  default: {
    ordererBusinessName: "",
    ordererPhone: "",
    ordererMail: "",
    ordererName: "",
    constructionName: "",
    constructionWorkName: "",
  },
});
